import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, { color: "rgba(0,0,0,0)" }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "font-weight-bold" }, "Welcome 👋", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", null, [
        _createElementVNode("p", null, [
          _createElementVNode("b", null, " I'm Architecting, Developing and Designing Platforms serving MILLIONS of users and improving their lives through the ideas I materalize in reality. "),
          _createElementVNode("br"),
          _createElementVNode("br"),
          _createTextVNode(" During the last 15 years, I've treated my work seriously as a "),
          _createElementVNode("b", null, " OLYMPIAN-LEVEL ATHLETE"),
          _createTextVNode(" would do. "),
          _createElementVNode("br"),
          _createTextVNode(" I've decided at the beginning of my life, that I want to perform at the World-class level. "),
          _createElementVNode("br"),
          _createTextVNode(" I kept advancing my understanding of the body, soul and the mind, evolving myself continously and showcasing it through the Software I'm crafting and architecting. ")
        ]),
        _createElementVNode("br"),
        _createElementVNode("p", null, [
          _createTextVNode(" I've competed succesfully, for years, at the top level in Algorithm competitions, while researching and developing most-advanced algorithms. "),
          _createElementVNode("br"),
          _createTextVNode(" I've developed my own Operating system, to understand how things work from inside out. "),
          _createElementVNode("br"),
          _createTextVNode(" I've also worked with Medical Technology Companies, based in United States of America, working with highest-security standards known in the Industry; I've also worked with companies from Netherlands, United Kingdom, Germany etc.. "),
          _createElementVNode("br"),
          _createTextVNode(" I've Architected, Designed and Developed, primarily in TypeScript: numerous successful Educational, Analytical, SaaS platforms: "),
          _createElementVNode("b", null, " DESIGNED AND TESTED IN SERVING MILLIONS OF USERS.")
        ]),
        _createElementVNode("br"),
        _createElementVNode("p", null, [
          _createTextVNode(" I've led teams comprised of 25 members, with complete and detailed understanding of "),
          _createElementVNode("b", null, " THE COMPLETE SOFTWARE DEVELOPMENT CYCLE"),
          _createTextVNode(": from architecting, designing, developing backend and frontend platforms, with unbridled complexity and utmost simplicity in solutions that solve problems and ensure long-term stability. "),
          _createElementVNode("br"),
          _createTextVNode(" My utmost priority is to treat every project and a team member, like a "),
          _createElementVNode("b", null, " OLYMPIAN-LEVEL CHALLENGE and ATHLETE"),
          _createTextVNode(", just like I treat myself and hold myself to these standards. I expect and demand same from every member. "),
          _createElementVNode("br"),
          _createTextVNode(" I've written and outlined my principles of development that are battle-tested, in numerous "),
          _createElementVNode("strong", null, "essays, which got recognized and featured by MEDIUM.com staff, on their HOMEPAGE"),
          _createTextVNode(", and numerous developers that used them to super-charge their workflow and approach to life and work; many of them have since become top-level developers and successful people. ")
        ]),
        _createElementVNode("br"),
        _createElementVNode("p", null, [
          _createTextVNode(" I suggest you to check out my GitHub repositories to find all ideas in action. "),
          _createElementVNode("br"),
          _createTextVNode(" From world's best SHOPIFY open-source tool out-there... To robust and well-crafted Habit tracker, that is extremely powerful and open-source... Operating system, written in C and Assembly, bleeding-edge Blockchain projects etc. ")
        ]),
        _createElementVNode("br"),
        _createElementVNode("p", null, [
          _createTextVNode(" There is a lot of powerful platforms I've designed and crafted, published open-source, and I'm sure you will find them valuable and useful. "),
          _createElementVNode("br"),
          _createElementVNode("b", null, " ALL OF THEM USE BLEADING-EDGE TECHNOLOGIES"),
          _createTextVNode(", different development paradigms and always push the envelope on what's possible. "),
          _createElementVNode("br"),
          _createTextVNode(" I'm proud of the crafting, and attention to the detail, that goes into the ideas I work on. "),
          _createElementVNode("br"),
          _createTextVNode(" They are well thought-out and thoroughly hand-crafted pieces of "),
          _createElementVNode("b", null, " ART "),
          _createTextVNode(". ")
        ]),
        _createElementVNode("br"),
        _createElementVNode("p", null, [
          _createTextVNode(" That being said, if you are a skilled and enthusiastic Architect, Developer or Designer, "),
          _createElementVNode("br"),
          _createTextVNode(" and if you value similiar ideas and approach as I do, "),
          _createElementVNode("br"),
          _createTextVNode(" and you function similiar to how I do,"),
          _createElementVNode("br"),
          _createTextVNode(" get in touch via e-mail, "),
          _createElementVNode("br"),
          _createTextVNode(" and support open-source projects I'm involved with. ")
        ]),
        _createElementVNode("br"),
        _createElementVNode("p", null, "Live Long and Prosper!")
      ], -1)),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
            _createElementVNode("h3", { class: "font-weight-bold" }, [
              _createTextVNode(" I'm an Architect of Systems and Products, "),
              _createElementVNode("br"),
              _createTextVNode(" with 15+ years of experience building robust, enterprise-grade and scalable systems, "),
              _createElementVNode("br"),
              _createTextVNode(" using bleading-edge technologies and architectural paradigms. ")
            ], -1),
            _createElementVNode("br", null, null, -1),
            _createElementVNode("h3", { class: "font-weight-bold" }, " Founded startups in the fields of Education and Sports and led teams of up to ten people. ", -1),
            _createElementVNode("br", null, null, -1),
            _createElementVNode("h3", { class: "font-weight-regular" }, " Worked, as a Systems Architect, Frontend, and Backend Developer, for a product company, a digital agency, and as a remote freelancer. ", -1),
            _createElementVNode("br", null, null, -1),
            _createElementVNode("h3", { class: "font-weight-regular" }, [
              _createTextVNode(" During my High School days, I've "),
              _createElementVNode("strong", null, "launched and managed web portals"),
              _createTextVNode(" on the topics of Sports, Gaming, and IT, worked as an "),
              _createElementVNode("strong", null, "IT reviewer"),
              _createTextVNode(" for an established Croatian site, "),
              _createElementVNode("strong", null, "competed at the National level in Algorithms"),
              _createTextVNode(", and "),
              _createElementVNode("strong", null, "built an Operating System for 32-bit Computers"),
              _createTextVNode(". ")
            ], -1),
            _createElementVNode("br", null, null, -1),
            _createElementVNode("h3", { class: "font-weight-regular" }, " Feel free to check the information I featured below, and get in touch if you have any interesting challenges. ", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    _: 1,
    __: [1,2,3]
  }))
}